<template>
  <div>
    <div
      class="upload-container"
      :class="isH5 ? 'h5-upload-container' : 'pc-upload-container'"
    >
      <div v-for="(item, index) in fileList" :key="index" class="image-item">
        <img
          @click="isH5 ? handlePreview(index) : () => {}"
          :src="item.url"
          alt=""
        />
        <span class="delete-box"
          ><i class="el-icon-zoom-in" @click="handlePreview(index)"
        /></span>
        <img
          @click="deleteImage(index)"
          class="close-icon"
          src="../../../assets/images/close-icon.png"
          alt=""
        />
      </div>
      <el-upload
        v-show="limit > fileList.length"
        :style="`max-width:${uploadWidth}px;`"
        class="upload-btn"
        :class="{ 'tips-position__right': tipsPosition === 'right' }"
        :limit="limit"
        action="#"
        :auto-upload="false"
        list-type="picture-card"
        :on-change="changeImage"
        :show-file-list="false"
        :file-list="fileList"
        :accept="accept"
      >
        <p class="uplod-text-wrap">
          <img
            class="upload-icon"
            src="../../../assets/images/upload-icon.png"
            alt=""
          />
          <span class="upload-text">添加图片</span>
        </p>
      </el-upload>
    </div>
    <el-image
      style="display: none"
      ref="elImage"
      :initial-index="initialIndex"
      src=""
      :preview-src-list="previewList"
    ></el-image>
  </div>
</template>

<script>
import { cosUploadFile } from "@saas/components/src/utils/cos-upload";
import { getUploadSignature } from "@saas/service-api/src/material/index.js";
import { isH5, handleImageUrl } from "@saas/components";
import { postFile } from "@saas/service-api/src/request.js";
export default {
  props: {
    // 获取sts的api
    stsApi: {
      type: String,
      default: "",
    },
    // 获取sts的参数
    stsParams: {
      type: Object,
      default: () => ({}),
    },
    value: {
      type: [String, Array],
      default: () => [],
    },
    // 限制数量
    limit: {
      type: Number,
      default: 1,
    },
    // 限制大小 单位MB
    limitSize: {
      type: Number,
      default: 10,
    },
    // 限制图片类型
    limitType: {
      type: Array,
      default: () => ["jpg", "jpeg", "png"],
    },
    tips: {
      type: String,
      default: "",
    },
    // 上传按钮和tips的最大宽度
    uploadWidth: {
      type: Number,
      default: 300,
    },
    // 提示位置,底部或右边
    tipsPosition: {
      type: String,
      default: "bottom",
    },
    // 绑定值的类型 string: ['xxxxxx', 'xxxxx'], object: [{name: 'xxxx', url: 'xxxx'}]
    dataType: {
      type: String,
      default: "string",
    },
  },
  data() {
    return {
      cos: null,
      fileList: [],
      stsToken: null,
      sts: {},
      previewImages: [],
      isH5: isH5(),
      initialIndex: 0,
    };
  },
  computed: {
    accept() {
      return this.limitType.reduce((pre, cur) => {
        return pre + "." + cur + ",";
      }, "");
    },
    previewList() {
      if (this.fileList?.length) {
        return this.fileList.map((item) => {
          return item.url;
        });
      } else {
        return [];
      }
    },
  },
  watch: {
    value: {
      handler(val) {
        if (val) {
          if (
            this.limit === 1 &&
            this.dataType === "string" &&
            typeof val === "string"
          ) {
            this.fileList = [{ url: val }];
          } else if (
            this.limit > 1 &&
            this.dataType === "string" &&
            Array.isArray(val)
          ) {
            this.fileList = val.map((item) => {
              return { url: item };
            });
          } else if (
            this.limit === 1 &&
            this.dataType === "object" &&
            Object.prototype.toString.call(val) === "[object Object]"
          ) {
            this.fileList = [val];
          } else {
            this.fileList = val;
          }
        } else {
          this.fileList = [];
        }
        console.log(this.fileList);
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    handlePreview(index) {
      this.initialIndex = index;
      this.$refs.elImage.clickHandler();
    },
    checkFormat(file) {
      const fileType = file?.raw?.type?.split("/")?.[1] || "";
      return this.limitType.includes(fileType);
    },
    checkSize(file) {
      return file.size / 1024 / 1024 <= this.limitSize;
    },
    emitInput() {
      if (this.dataType === "string") {
        const list = this.fileList.map((item) => {
          return item.url;
        });
        if (+this.limit === 1) {
          this.$emit("input", list[0]);
        } else {
          this.$emit("input", list.slice(0, +this.limit));
        }
      } else {
        this.$emit("input", this.fileList.slice(0, +this.limit));
      }
      if (this.$parent?.elForm) {
        this.$parent.$emit("el.form.change");
      }
    },
    changeImage(file) {
      if (!this.checkFormat(file)) {
        const formatList = this.limitType.join("、");
        this.$message.error(`请上传 ${formatList} 格式图片!`);
        return false;
      }
      if (!this.checkSize(file)) {
        this.$message.error(`上传图片大小不能超过${this.limitSize}M!`);
        return false;
      }
      if (this.stsApi === "/v1/cos/getSign") {
        this.apiGetSign(file);
      } else {
        this.getStsData(file);
      }
    },
    // todo:test
    apiGetSign(fileData) {
      getUploadSignature({
        fileName: fileData.name,
        ...this.stsParams,
      })
        .then((res) => {
          if (res.code === 1) {
            fileData.cos = cosUploadFile(
              {
                file: fileData.raw,
                fileName: fileData.name,
                type: this.stsParams.materialType,
              },
              {
                ...res.data,
              },
              {
                onFileFinish: (err, data, options) => {
                  if (data && data.statusCode === 200) {
                    console.log("onFileFinish-data", data);
                    const url = data.Location.startsWith("https://")
                      ? data.Location
                      : "https://" + data.Location;
                    this.fileList.push({
                      url: url,
                    });
                    this.emitInput();
                  } else {
                    console.log(err);
                  }
                },
              }
            );
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getStsData(file) {
      postFile(this.stsApi, {
        img: [file.raw],
      }).then((res) => {
        if (res.code === 1) {
          this.fileList.push({
            url: handleImageUrl(res.data[0]),
          });
          this.emitInput();
        } else {
          this.$message.error(res.message);
          this.emitInput();
        }
      });
    },
    deleteImage(index) {
      this.fileList.splice(index, 1);
      this.emitInput();
    },
  },
};
</script>
<style lang="scss" scoped>
.pc-upload-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;

  .upload-btn ::v-deep {
    .el-upload {
      position: relative;
      width: 90px;
      height: 90px;
      background: #f7f8f9;
      border-radius: 14px;
      border: none;
    }

    .el-upload__tip {
      line-height: 24px;
    }
  }
  .uplod-text-wrap {
    width: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .upload-icon {
      width: 21.6px;
      height: 21.6px;
    }

    .upload-text {
      font-weight: 400;
      font-size: 16px;
      color: #515350;
      line-height: 22px;
      margin-top: 6px;
    }
  }

  .tips-position__right {
    display: flex;

    ::v-deep .el-upload {
      width: 148px;
      height: 148px;
    }

    .el-upload__tip {
      flex: 1;
      margin-left: 10px;
      line-height: 24px;
    }
  }

  .image-item {
    position: relative;
    width: 90px;
    height: 90px;
    border-radius: 14px;
    border: 1px solid #efefef;
    // overflow: hidden;
    background-color: #fff;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    margin: 0 16px 0 0;
    display: inline-block;
    object-fit: contain;

    img {
      width: 100%;
      height: 100%;
      border-radius: 14px;
      object-fit: cover;
    }
    .close-icon {
      position: absolute;
      width: 24px;
      height: 24px;
      top: -4px;
      right: -12px;
      cursor: pointer;
    }
    .delete-box {
      position: absolute;
      border-radius: 14px;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      cursor: default;
      text-align: center;
      color: #fff;
      opacity: 0;
      font-size: 20px;
      background-color: rgba(0, 0, 0, 0.5);
      -webkit-transition: opacity 0.3s;
      transition: opacity 0.3s;
      display: flex;
      justify-content: center;
      align-items: center;

      i {
        cursor: pointer;
        left: 50%;
        padding: 5px;
      }

      &:hover {
        opacity: 1;
      }
    }
  }
}

.h5-upload-container {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;

  .upload-btn ::v-deep {
    .el-upload {
      position: relative;
      width: 2rem;
      height: 2rem;
      background: #f7f8f9;
      border-radius: 0.32rem;
      border: none;
    }
    margin-bottom: 0.24rem;
  }

  .uplod-text-wrap {
    width: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .upload-icon {
      width: 0.48rem;
      height: 0.48rem;
    }

    .upload-text {
      font-weight: 400;
      font-size: 0.29rem;
      color: #515350;
      line-height: 0.4rem;
      margin-top: 0.13rem;
    }
  }

  .tips-position__right {
    display: flex;

    ::v-deep .el-upload {
      width: 2rem;
      height: 2rem;
    }
  }

  .image-item {
    position: relative;
    width: 2rem;
    height: 2rem;
    border-radius: 0.32rem;
    border: 0.01rem solid #efefef;
    // overflow: hidden;
    background-color: #fff;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    margin: 0 0.24rem 0.24rem 0;
    display: inline-block;
    object-fit: contain;

    img {
      width: 100%;
      height: 100%;
      border-radius: 0.32rem;
      object-fit: cover;
    }
    .close-icon {
      position: absolute;
      width: 0.4rem;
      height: 0.4rem;
      top: -0.05rem;
      right: -0.1rem;
    }
    .delete-box {
      display: none;
    }
  }
  .image-item:nth-child(4n) {
    margin-right: 0;
  }
}
</style>
